// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayServiceClientsEnumsAddressType } from './tCApiGatewayServiceClientsEnumsAddressType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersAccountModelsSharedAddressPatientDataModel {
    'addressType'?: TCApiGatewayServiceClientsEnumsAddressType;
    'addressOne'?: string | null;
    'addressTwo'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'zip'?: string | null;
    'country'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersAccountModelsSharedAddressPatientDataModel>> = [
        {
            "name":     "addressType",
            "baseName": "addressType",
            "type":     "TCApiGatewayServiceClientsEnumsAddressType"
        },
        {
            "name":     "addressOne",
            "baseName": "addressOne",
            "type":     "string"
        },
        {
            "name":     "addressTwo",
            "baseName": "addressTwo",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "zip",
            "baseName": "zip",
            "type":     "string"
        },
        {
            "name":     "country",
            "baseName": "country",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersAccountModelsSharedAddressPatientDataModel.attributeTypeMap;
    }
}
